import { DataAccesBarWrapper, DataAccesBarLeft, DataAccesBarRight, AccessOptionsBar, AccessOptionsBarLeft, AccessOptionsBarRight, MainContainer, SearchContainer } from "./DataAccesBar.styled";
import { TextField, SwitchMode, ButtonsList, Button, Typography } from "@ann/web-components";
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback, useMemo, useTransition } from 'react';
import { useStore } from '../../../../../../../hooks';
import useDebounce from '../../../../../../../hooks/useDebounce';

const DataAccesBar = ({ viewMode, setViewMode, onSearchChange }) => {
    const [selectedTab, setSelectedTab] = useState('drives');
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const { knowledgeStore } = useStore();
    
    // ✅ PERFORMANCE: Use React transition to prevent blocking UI
    const [isPending, startTransition] = useTransition();

    // Implementar debouncing para mejor rendimiento (usa valor por defecto de 700ms del hook)
    const debouncedSearchTerm = useDebounce(searchTerm);

    // Determinar la pestaña activa basándose en la URL actual
    useEffect(() => {
        const path = location.pathname;
        if (path.includes('/documents')) {
            setSelectedTab('documents');
        } else if (path.includes('/drives')) {
            setSelectedTab('drives');
        }
    }, []);

    // Inicializar el store cuando se monta el componente
    /*useEffect(() => {
        if (knowledgeStore && !knowledgeStore.isInitialized) {
            knowledgeStore.initializeStore();
        }
    }, [knowledgeStore]);*/

    // Efecto para propagar el término de búsqueda debounced
    useEffect(() => {
        if (onSearchChange) {
            onSearchChange(debouncedSearchTerm);
        }
    }, [debouncedSearchTerm, onSearchChange]);

    // ✅ PERFORMANCE: Memoized callbacks
    const handleSearchChange = useCallback((value) => {
        setSearchTerm(value);
    }, []);

    const handleTabChange = useCallback((tab) => {
        console.time(`⏱️ Tab switch to ${tab}`);
        console.log(`🔄 Starting tab switch to: ${tab}`);
        
        // ✅ PERFORMANCE: Update UI immediately (non-blocking)
        setSelectedTab(tab);
        console.log(`✅ Tab state updated to: ${tab}`);
        
        // ✅ PERFORMANCE: Wrap expensive operations in transition (non-blocking)
        startTransition(() => {
            console.log(`🚀 Transition started for: ${tab}`);
            setSearchTerm('');
            if (onSearchChange) {
                onSearchChange('');
            }
            console.log(`🧭 Navigating to: ${tab}`);
            navigate(tab);
            console.timeEnd(`⏱️ Tab switch to ${tab}`);
            console.log(`✅ Navigation completed to: ${tab}`);
        });
    }, [navigate, onSearchChange, startTransition]);

    // ✅ PERFORMANCE: Memoized button items with stable callbacks
    const buttonItems = useMemo(() => [
        {
            label: 'Shared Drives',
            onClick: () => handleTabChange('drives'),
            selected: selectedTab === 'drives'
        },
        {
            label: 'Uploaded Files',
            onClick: () => handleTabChange('documents'),
            selected: selectedTab === 'documents'
        },
    ], [selectedTab, handleTabChange]);

    return (
        <MainContainer>
            <DataAccesBarWrapper>
                <DataAccesBarLeft>
                    <SearchContainer>
                        <TextField
                            iconLeft="search"
                            onChange={handleSearchChange}
                            size="small"
                            placeholder="Shared drive name"
                            value={searchTerm}
                        />
                    </SearchContainer>

                    <ButtonsList
                        items={buttonItems}
                        size="medium"
                    />

                </DataAccesBarLeft>
                <DataAccesBarRight>
                    <SwitchMode
                        mode={viewMode}
                        onModeChange={setViewMode}
                    />
                </DataAccesBarRight>

            </DataAccesBarWrapper>

        </MainContainer>
    );
};

export default DataAccesBar;